import { BackButton } from '@common/components/BackButton';
import { Box, ScrollArea } from '@radix-ui/themes';
import { useRef } from 'react';
import { Background } from '../components';
import { PreviewTab } from '../components/Preview/PreviewTab';

// type TAB_NAMES = 'preview' | 'operations' | 'contracts';
// const TABS: [string, React.ReactNode][] = Object.entries({
//     preview: <PreviewTab />,
//     operations: <OperationsTab />,
//     contracts: <Text size='2'>Collection contracts</Text>,
// });

export const CollectionDetailsPage = () => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    // const { t } = useTranslation('collectionDetails');
    return (
        <Background scrollRef={scrollContainerRef}>
            <ScrollArea ref={scrollContainerRef} type='scroll'>
                <Box m={'3'} height={'100%'}>
                    <BackButton />
                    {/* <Tabs.Root defaultValue='preview'>
                        <Card asChild>
                            <Tabs.List
                                style={{
                                    width: 'fit-content',
                                    height: 'fit-content',
                                    padding: 0,
                                    top: 'var(--space-4)',
                                    left: '8%',

                                    position: 'absolute',
                                    zIndex: 1,
                                }}
                            >
                                {TABS.map(([value]) => (
                                    <Tabs.Trigger value={value} key={value}>
                                        {t(`tabs.${value}`)}
                                    </Tabs.Trigger>
                                ))}
                            </Tabs.List>
                        </Card>

                        <Box px={'5'}>
                            {TABS.map(([value, node]) => (
                                <Tabs.Content value={value} key={value}>
                                    {node}
                                </Tabs.Content>
                            ))}
                        </Box>
                    </Tabs.Root> */}
                    <PreviewTab />
                </Box>
            </ScrollArea>
        </Background>
    );
};
